module.exports = __webpack_public_path__ + "img/area-part3-132.4d53f075.png";